import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { getProducts } from '../../mobileMenuProducts'
import { AccordionMenu } from '../AccordionMenu'
import { ConsumerCallout } from './ConsumerCallout'
import { useIsNewForBusinessPageEnabled } from './hooks'

const Search = dynamic(
  () => import('components/Navigation/shared/Mobile/Search'),
  { ssr: false },
)

export const MobileMenuVariant3 = () => {
  const { pathname, query } = useRouter()
  const newForBusinessPageEnabled = useIsNewForBusinessPageEnabled()

  const PRODUCTS = getProducts({
    pathname,
    query: query as Record<string, string>,
    newForBusinessPageEnabled,
    Callout: <ConsumerCallout />,
    productType: 'consumer',
    onCallLinksEnabled: true,
  })

  return (
    <>
      <Search />
      <AccordionMenu
        products={PRODUCTS}
        defaultExpandedProduct='consumer'
        productSectionClassName='mc-bg-container-tint-medium'
      />
    </>
  )
}
